export default __webpack_public_path__ + "b0e15e81d795eecfae4c876af3ed82bf.png";